import styled, { css } from 'styled-components/macro';
import media from '../media';

function getFlex(col) {
  switch (col) {
    case col > 60 && col < 70:
      return `flex: 0 1 calc(${col}% - 2px);`;

    case 33:
      return `flex: 0 1 calc(33.33% - 16px);`;

    default:
      return `flex: 0 1 calc(${col}% - 16px);`;
  }
}

function createCol(col) {
  const baseCss = `
    flex-basis: 100%;
    margin: 7px 0;
    min-width: 0;
  `;
  if (!col) {
    return css`
      ${baseCss}
      max-width: 100%;
    `;
  }
  if (col < 60) {
    return css`
      ${baseCss}
      ${media.desktop`
    ${getFlex(col)}`}
    `;
  }
  return css`
    ${baseCss}
    max-width: 100%
    ${media.desktop`
      ${getFlex(col)};
    `};
  `;
}

export const Row = styled.div`
  padding: 0;
  margin: ${({ margin }) => margin || '0'};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${({ flexStart }) =>
    flexStart ? 'flex-start' : 'space-between'};

  &:last-child {
    margin-bottom: 0;
  }
  ${({ hasBorderBottom }) =>
    hasBorderBottom &&
    css`
      &:after {
        content: '';
        border-bottom: 1px solid ${({ theme }) => theme.divider};
        width: 100%;
        margin-bottom: 30px;
        padding-top: 15px;
      }
    `}

  ${({ flexStart }) =>
    flexStart &&
    css`
      > div:not(:last-child) {
        ${({ keepSize }) => keepSize || 'margin-right: 25px'};
        ${media.desktop`
          margin-right: 25px;
        `}
      }
    `}
  ${media.desktop`
  ${({ growLast, columns }) =>
    growLast &&
    `
      > div:last-child {
        flex: 0 1 calc(${(100 / columns) * 2}% - 20px);
      }
    `}
  `}
  fieldset {
    max-width: 100%;
  }
  ${media.desktop`
      flex-direction: row;
  `};
  &:not(:last-child) {
  }
  > div {
    margin-bottom: 20px;

    ${({ columns }) =>
      columns &&
      css`
        flex: 0 1 calc(100%);
        ${({ keepSize }) => keepSize && `flex: 0 1 calc(${100 / columns}%);`}
        ${media.desktop`
          flex: 0 1 calc(${100 / columns}% - 20px);
        `}
      `}
  }
`;

export const Col = styled.div`
  display: flex;
  ${({ column }) => column && 'flex-direction: column;'}
  ${({ center }) => center && 'align-items: center'};
  ${({ col }) => createCol(col)};
  > * {
    flex-grow: ${({ growChild = true }) => (growChild ? '1' : '0')};
  }
`;
